<template>
	<button
		type="button"
		ref="button"
		aria-haspopup="listbox"
		:aria-expanded="expanded.toString()"
		:aria-labelledby="labelledBy"
		:class="{ active: expanded }"
		tabindex="0"
		@click="toggle"
		@focusout="() => $emit('faset-focusout')"
		@keydown.enter.prevent="open"
		@keydown.down.prevent="selectDown"
		@keydown.up.prevent="selectUp"
	>
		<slot />
	</button>
</template>

<script>
import { SelectButton } from "../mixins";

export default {
	name: "SelectButton",

	mixins: [SelectButton]
};
</script>
